module.exports = __webpack_public_path__ + "static/img/zhongduwumai1.0c27e9de.png";